import { useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function GAScript() {
  useEffect(() => {
    axios.get(`${API}/settings/analytics`).then((res) => {
      const id = res.data?.ga_measurement_id;
      if (id && id.startsWith("G-")) {
        const script = document.createElement("script");
        script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
        script.async = true;
        document.head.appendChild(script);
        window.dataLayer = window.dataLayer || [];
        function gtag() { window.dataLayer.push(arguments); }
        window.gtag = gtag;
        gtag("js", new Date());
        gtag("config", id);
      }
    }).catch(() => {});
  }, []);
  return null;
}
